export default "__VITE_ASSET__DKhfMrG2__"